module.exports = __webpack_public_path__ + "media/images/athletes/80-2726d57fd0d94eb801fbf0f83854b8ab.png";